/*
 * File: useDebugStateChange.ts
 * Project: meki
 * File Created: Monday, 28th September 2020 10:45:35 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Thursday, 11th February 2021 10:59:57 am
 * Modified By: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { Console } from '@utils';
import { useEffect, useRef } from 'react';

export function useDebugStateChange(msg: string, state: unknown) {
  const valueRef = useRef(state);
  useEffect(() => {
    Console.log(msg, { from: valueRef.current, to: state });
    valueRef.current = state;
  }, [state, msg]);
}
